module.exports = __webpack_public_path__ + "media/images/flags/ki-2b01c8d7133515438f54bca721368f43.svg";